module.exports = __webpack_public_path__ + "static/media/top_banner_10.1c161c5d.png";